import { render, staticRenderFns } from "./modalAddDeeplinkCampaign.vue?vue&type=template&id=3923f5f7&"
import script from "./modalAddDeeplinkCampaign.vue?vue&type=script&lang=js&"
export * from "./modalAddDeeplinkCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports